import { render, staticRenderFns } from "./AiStatCard.vue?vue&type=template&id=012d5ead&scoped=true&"
import script from "./AiStatCard.vue?vue&type=script&lang=js&"
export * from "./AiStatCard.vue?vue&type=script&lang=js&"
import style0 from "./AiStatCard.vue?vue&type=style&index=0&id=012d5ead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012d5ead",
  null
  
)

export default component.exports